import React from "react";
import { useStyles } from "../../assets/jss/NotificationBar";
import DateTime from "../DateTime/DateTime";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import {
  CustomPlayCircleOutlineIcon,
  CustomHelpOutlineIcon,
  CustomChatIcon,
} from "../CustomComponents/CustomIcon/CustomIcon";
import { CampaignTypeEnum, ContentType } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function NotificationBar(props) {
  const params = useParams();
  const { t } = useTranslation();
  const { onClick } = props;
  const classes = useStyles();
  const [notifications] = React.useState(props.data);
  const [isLoading] = React.useState(props.loading);

  return (
    <>
      <div className={classes.notificationBarOverlay} onClick={onClick}></div>
      <div
        className={classes.notificationDrawer}
        id="notificationBar"
        onClick={onClick}
      >
        <div className={classes.notificationBarTitle}>Notification</div>
        <div className={classes.notificationBarList}>
          {isLoading && (
            <div className={classes.loader}>
              <CustomCircularProgress />
            </div>
          )}

          {notifications && notifications.length === 0 && isLoading === false && (
            <CustomTypography
              variant="h5"
              component="h5"
              className={classes.noNotificationText}
            >
              {t("NO_NEW_NOTIFICATIONS")}
            </CustomTypography>
          )}

          {notifications && notifications.length
            ? notifications.map((item, index) => {
              return (
                <div
                  key={`notification-${index}`}
                  className={classes.notificationBarItem}
                >
                  <a
                    className={classes.card}
                    href={params.impersonationid ? `/impersonation/${params.impersonationid}/contents/${item.contentId}` : `/contents/${item.contentId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className={classes.cardIcon}>
                      <div className={classes.icon}>
                        {item.contentTypeId === ContentType.DRIVING_VIDEO ? (
                          <CustomPlayCircleOutlineIcon />
                        ) : item.contentTypeId ===
                          ContentType.EMAIL_MESSAGE ? (
                          <CustomChatIcon />
                        ) : item.contentTypeId === ContentType.ANIMATION ? (
                          <CustomPlayCircleOutlineIcon />
                        ) : item.contentTypeId === ContentType.ARTICLE ? (
                          <CustomChatIcon />
                        ) : item.contentTypeId === ContentType.QUIZ ? (
                          <CustomHelpOutlineIcon />
                        ) : (
                          <CustomPlayCircleOutlineIcon />
                        )}
                      </div>
                    </div>
                    <div className={classes.cardContent}>
                      <div className={classes.date}>
                        <DateTime
                          inputDate={item.assignedDate}
                          returnFormat="ddd"
                        />
                        ,{" "}
                        <DateTime
                          inputDate={item.assignedDate}
                          returnFormat="DD MMM YYYY"
                        />
                      </div>
                      <div className={classes.title}>{item.title}</div>
                      {item.campaignTypeId !== CampaignTypeEnum.PeriodicReportMessage && <div
                        className={classes.desc}
                        dangerouslySetInnerHTML={{
                          __html: item.emailMessageBody,
                        }}
                      />}
                    </div>
                  </a>
                </div>
              );
            })
            : null}
        </div>
      </div>
    </>
  );
}
